<template>
  <div class="custom-input">
    <input
      ref="customInput"
      type="tel"
      v-mask="'###'"
      :value="modelValue"
      @input="+$event.target.value ? $emit('update:modelValue', +$event.target.value) : null"
      @blur="blur"
    />
    <span
      class="input-control increase"
      @click="$emit('update:modelValue', modelValue + 1)"
    />
    <span
      class="input-control decrease"
      @click="modelValue > 1 ? $emit('update:modelValue', modelValue - 1) : null"
    />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'CustomNumberInput',

  directives: {
    mask,
  },

  props: {
    modelValue: {
      type: [Number, String],
      default: 0,
    },
  },

  methods: {
    blur() {
      if (!this.$refs.customInput.value) {
        this.$emit('update:modelValue', 1);
        this.$refs.customInput.value = 1;
      } else {
        this.$refs.customInput.value = +this.$refs.customInput.value;
      }
    },
  }
};
</script>

<style lang="sass" scoped>
  .custom-input
    width: 102px
    position: relative
    input
      border: 0
      margin: 0
      background: #303B50
      border-radius: 4px
      width: 100%
      color: #fff
      padding: 0
      font-size: 16px
      line-height: 16px
      font-weight: 600
      height: 32px
      padding: 0 0 0 12px
    .input-control
      cursor: pointer
      display: inline-block
      width: 14px
      height: 9px
      position: absolute
      right: 6px
      &::before
        content: ''
        border-left: 5px solid transparent
        border-right: 5px solid transparent
        width: 0
        height: 0
        top: 2px
        left: 2px
        position: absolute
    .increase
      top: 6px
      &::before
        border-bottom: 5px solid #fff
    .decrease
      top: 19px
      &::before
        border-top: 5px solid #fff     
</style>